import { render, staticRenderFns } from "./episode.vue?vue&type=template&id=131d4924"
import script from "./episode.vue?vue&type=script&lang=js"
export * from "./episode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports